import React from 'react';
import { Icon } from './Icon.js';
export const IconConversion = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M5 15L11 21H12L12.5 18H22V14H5V15Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M19 9L13 3H12L11.5 6H2V10H19V9Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconConversion.js.map